export const environment = {
  production: false,
  baseUrl: 'https://abg-callcenter-api.abg-mynd.com',


  avatarStaticBase: '/avatar',
  defaultCountry: 'LB',
  version: '1.0.0',
  appVar: 'callcenter',
  ssoBaseUrl: 'https://abg-reporting-api.abg-ace.ai/sso',
  auth: {
    login: '/ace/sc/api/auth',
    logout: '/ace/sc/api/auth/logout',
    refreshToken: '/ace/sc/api/auth/refreshToken',
    oauth: '/api/oauth',
  },

  outOfScope: {
    getAll: '/chat/api/out-of-scope',
  },

  avatarConfiguration: {
    getAvatars: '/avatar/api/v1/avatar',
    getByAvatar: '/avatar/api/v1/avatar-configuration/avatar',
    updateKnowledgeBase:
      '/avatar/api/v1/avatar-configuration/update-knowledge-base',
  },

  avatarPersonalization: {
    getAvatars: '/avatar/api/v1/avatar',
    getMediaAssets: '/avatar/api/v1/media-asset',
    selectAvatar: '/avatar/api/v1/avatar/selection',
    assignMediaAsset: '/avatar/api/v1/avatar/media-asset',
    uploadMediaAsset: '/avatar/api/v1/media-asset',
    deleteMediaAsset: '/avatar/api/v1/media-asset',
  },

  avatarSettings: {
    getAvatars: '/avatar/api/v1/avatar',
    getSelectedAvatar: '/avatar/api/v1/avatar/selected',
    getSettings: '/avatar/api/v1/avatar-setting',
    updateSettings: '/avatar/api/v1/avatar-setting',
    getVoiceSettings: '/chat/api/v1/voice-setting',
    updateVoiceSetting: '/avatar/api/v1/avatar/voice-setting',
  },

  dashboard: {
    getMetrics: '/avatar-audit/avatar-metrics/get-metrics',
  },

  curriculum: {
    programs: '/program/api/programs',
    programStages: '/program/api/program-stages',
    subjects: '/program/api/subjects',
    topics: '/program/api/topics',
    learningObjectives: '/program/api/learning-objectives',
  },

  playlists: {
    base: '/api/v1/playlist',
    withVideos: '/api/v1/playlist/with-videos',
  },

  playlistVideos: {
    base: '/api/v1/playlist-video',
    upload: '/api/v1/playlist-video/upload',
    search: '/api/v1/playlist-video/search',
  },

  noiseWords: {
    base: '/chat/api/noise-dictionary',
    categories: '/chat/api/noise-dictionary/category/all',
    logs: '/chat/api/noise-dictionary/logs',
  },

  businessHours: {
    schedules: {
      base: '/system/api/v1/business-hours-schedules',
      all: '/system/api/v1/business-hours-schedules/all',
      byId: '/system/api/v1/business-hours-schedules',
      byBusinessHoursId:
        '/system/api/v1/business-hours-schedules/business-hours',
      delete: '/system/api/v1/business-hours-schedules/delete',
    },
    specialDays: {
      base: '/system/api/v1/business-hours-special-days',
      all: '/system/api/v1/business-hours-special-days/all',
      byId: '/system/api/v1/business-hours-special-days',
      byBusinessHoursId:
        '/system/api/v1/business-hours-special-days/business-hours',
      delete: '/system/api/v1/business-hours-special-days/delete',
    },
  },

  learnerManagement: {
    learners: '/learner/api/learners',
    guardians: '/learner/api/guardians',
    learnerGuardians: '/learner/api/learner-guardians',
    programEnrollments: '/learner/api/program-enrollments',
    programEnrollmentsByLearner: '/learner/api/program-enrollments/learner',
    courseEnrollments: '/learner/api/course-enrollments',
    courseFeedbacks: '/learner/api/course-feedbacks',
    ebookNotes: '/learner/api/ebook-notes',
    highlightAreas: '/learner/api/highlight-areas',
  },
  companyManagement: {
    company: {
      all: '/company/api/company/all',
      base: '/company/api/company',
    },
    intern: {
      all: '/company/api/intern/all',
      base: '/company/api/intern',
    },
  },
  courseManagement: {
    coursesAll: '/course/api/v1/courses/all',
  },
  instructorManagement: {
    instructors: '/instructor/api/instructors',
  },
  outboundCalls: {
    inquiries: '/contact/api/inquiries',
    callLogs: '/audit/api/v1/call-logs',
    callLogKpis: '/audit/api/v1/call-logs/kpis',
    callQueue: '/contact/api/v1/call-queue',
    llmUpdateLogs: '/contact/api/llm-update-logs',
  },
  campaign: {
    base: '/campaign/api/v1/campaign',
  },
  dnc: {
    base: '/contact/api/v1/dnc',
  },
  contacts: {
    base: '/contact/api/v1/contacts',
  },
  agents: {
    base: '/agent/api/v1/agents',
  },
  llmAgents: {
    base: '/agent/api/v1/llm-agents',
    voices: '/agent/api/v1/llm-agents/voices',
  },

  ui: {
    alertMessageTimeoutMs: 3000,
  },
  phoneCleanup: {
    enabled: true,
    countryCode: '+961',
  },
  assetBaseUrl: 'http://172.105.79.110/assets/ace',
};
